import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import CheckIcon from "@mui/icons-material/Check";
const useStyles = makeStyles(theme => ({
  completeContainer: {
    width: 24,
    height: 24,
    margin: "auto"
  },
  incompleteContainer: {
    position: "relative"
  },
  icon: {
    color: ({
      error
    }) => error ? theme.palette.error.main : theme.palette.text.secondary,
    fontSize: 18,
    position: "absolute"
  },
  checkIcon: {
    left: 5
  },
  upsideDownCheck: {
    transform: "rotate(180deg)",
    fontSize: 16,
    top: 9,
    left: 2
  },
  completeIcon: {
    color: theme.palette.success.main
  }
}));
const CompleteIncompleteIcon = ({
  customCompleteContainer,
  complete = true,
  error = false
}) => {
  const classes = useStyles({
    error
  });
  return /*#__PURE__*/React.createElement("div", {
    className: customCompleteContainer ? customCompleteContainer : classes.completeContainer
  }, complete ? /*#__PURE__*/React.createElement(CheckIcon, {
    className: classes.completeIcon
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.incompleteContainer
  }, /*#__PURE__*/React.createElement(CheckIcon, {
    className: `${classes.checkIcon} ${classes.icon}`
  }), /*#__PURE__*/React.createElement(CheckIcon, {
    className: `${classes.upsideDownCheck} ${classes.icon}`
  })));
};
export default CompleteIncompleteIcon;
CompleteIncompleteIcon.propTypes = {
  customCompleteContainer: PropTypes.string,
  complete: PropTypes.bool,
  error: PropTypes.bool
};